<template>
  <div class="container page">
    <!-- 固定顶部导航栏 -->
    <div class="fixed-nav">
      <van-nav-bar :title="$t('setting.fill_bank')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <!-- 表单区域 -->
    <div class="form-wrapper">
      <div class="form-card">
        <div class="form-item">
          <div class="form-label">{{$t('setting.username')}}</div>
          <van-field
            v-model="username"
            :placeholder="$t('setting.username_place')"
            class="form-field"
          />
        </div>
        <div class="form-item">
          <div class="form-label">{{$t('setting.band_name')}}</div>
          <van-field
            v-model="bank"
            :placeholder="$t('setting.band_name_tip')"
            class="form-field"
          />
        </div>
        <div class="form-item">
          <div class="form-label">{{$t('setting.branch_name')}}</div>
          <van-field
            v-model="bankfenhang"
            :placeholder="$t('setting.branch_name_tip')"
            class="form-field"
          />
        </div>
        <div class="form-item">
          <div class="form-label">{{$t('setting.branch_code')}}</div>
          <van-field
            v-model="fhnumber"
            :placeholder="$t('setting.branch_code_tip')"
            class="form-field"
          />
        </div>
        <div class="form-item">
          <div class="form-label">{{$t('setting.band_account')}}</div>
          <van-field
            v-model="bankid"
            type="digit"
            :placeholder="$t('setting.band_account_tip')"
            class="form-field"
          />
        </div>
      </div>

      <!-- 提示信息 -->
      <div class="tip-box">
        <van-icon name="warning-o" color="#ff9800" size="18PX" />
        <span class="tip-text">{{$t("setting.bank_warn")}}</span>
      </div>

      <!-- 绑定按钮 -->
      <van-button 
        class="bind-btn" 
        block 
        color="linear-gradient(90deg, #ff5f6d, #ff2d55)" 
        @click="bindCard()"
      >
        {{$t("setting.bank_ok")}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank: false,
      userInfo: {},
      bankid: "",
      username: "",
      mobile: "",
      bank: "",
      bank_code: "",
      bankfenhang: '',
      fhnumber: ""
    };
  },
  methods: {
    back() {
      this.$router.push({path: '/Mine'});
    },
    bindCard() {
      if (this.userInfo.bankid) {
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if (this.bank === "" || this.bank === null || this.bank === undefined) {
        this.$toast.fail(this.$t("setting.band_name_tip"));
        return false;
      }
      if (this.userInfo.bankid) {
        this.$toast(this.$t("setting.band_account_tip"));
        return true;
      }
      if (this.username === "") {
        this.$toast(this.$t("setting.username_place"));
        return false;
      }
      if (this.bankfenhang === "") {
        this.$toast(this.$t("setting.branch_name_tip"));
        return false;
      }
      if (this.fhnumber === "") {
        this.$toast(this.$t("setting.branch_code_tip"));
        return false;
      }
      if (this.bankid === "") {
        this.$toast(this.$t("setting.band_account_tip"));
        return false;
      }
      
      this.$http({
        method: 'post',
        data: {
          bankid: this.bankid,
          bank: this.bank,
          username: this.username,
          bankfenhang: this.bankfenhang,
          fhnumber: this.fhnumber
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$router.push({path: '/Mine'});
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
  padding-top: 50PX; /* 顶部留出固定导航栏高度 */
}

/* 固定顶部导航栏 */
.fixed-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #8600ff;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #fff;
  }
}

/* 表单区域 */
.form-wrapper {
  padding: 20PX 15PX;
}

/* 表单卡片 */
.form-card {
  background: #fff;
  border-radius: 12PX;
  padding: 15PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
  margin-bottom: 15PX;
}

/* 每个表单项 */
.form-item {
  margin-bottom: 15PX;
}

.form-item:last-child {
  margin-bottom: 0;
}

/* Label 在输入框上方 */
.form-label {
  font-size: 14PX;
  color: #333;
  font-weight: 500;
  margin-bottom: 8PX;
}

.form-field {
  background: #f7f8fa;
  border-radius: 8PX;
  padding: 8PX 12PX;
  :deep(.van-field__control) {
    font-size: 15PX;
    color: #333;
  }
  :deep(.van-field__control::placeholder) {
    color: #999;
  }
}

/* 提示信息 */
.tip-box {
  display: flex;
  align-items: flex-start;
  gap: 8PX;
  background: #fff7e6;
  border-radius: 8PX;
  padding: 12PX 15PX;
  margin-bottom: 30PX;
}

.tip-text {
  font-size: 13PX;
  color: #ff9800;
  line-height: 20PX;
  flex: 1;
}

/* 绑定按钮 */
.bind-btn {
  height: 50PX;
  border-radius: 25PX;
  font-size: 16PX;
  font-weight: 600;
  color: #fff;
  border: none;
}

.bind-btn::after {
  border: none;
}
::v-deep .van-cell{
  font-size: 14PX;line-height: 32PX;
}
::v-deep .van-field__control {
  font-size: 14PX;line-height: 32PX;
  color: #333;
}

/* 修改 placeholder 字体大小 */
::v-deep  .van-field__control::placeholder {
  font-size: 14PX;line-height: 32PX;
  color: #999;
}
</style>